import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import H2 from "ReusableComponents/Text/H2";
import { useEffect, useState } from "react";
import { COLORS } from "theme";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useMediaQuery,
} from "@mui/material";
import { apiClient } from "api/apiClient";

const FaqComponent = () => {
  const small = useMediaQuery("(max-width: 768px)");

  const [faq, setFaq] = useState([]);

  useEffect((e) => {
    apiClient.getHiloadFaq().then((res) => {
      setFaq(res.data);
    });
  }, []);
  return (
    <Box
      display="flex"
      flexDirection="column"
      padding={small ? "40px 20px" : "0 80px"}
      marginBottom={small ? 0 : "10px"}
    >
      <H2
        textColor={COLORS.white}
        fontSize={small ? "16px" : "40px"}
        fontWeight="bold"
        margin={small ? 0 : "40px 0"}
        style={{textAlign:"center"}}
      >
        FAQ
      </H2>

      {faq.map((faq, index) => (
        <Accordion key={index} style={{ backgroundColor: "#1C1C1C" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: COLORS.white }} />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
          >
            <Text fontSize={small ? "14px" : "20px"} textColor="white">
              {faq.attributes.title}
            </Text>
          </AccordionSummary>
          <AccordionDetails>
            <Text fontSize={small ? "12px" : "16px"} textColor="#B8B8B8">
              {faq.attributes.description}
            </Text>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default FaqComponent;
